<template>
  <div @load="loadImage">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div >
    <div class="gameplay_game_box_list gameplay_tap_box">
      <div class="gameplay_tap_container pair">
      <div class="gameplay_tap_row" v-for="(row, rowIndex) in numOfRow" :key="row">
        <div class="card is-flipped" v-for="(answer, index) in numOfCols" :key="index"
             @click="sendAnswerUntilCompleted(twoDimensionalTable[rowIndex][index].mwDisplayIndex, twoDimensionalTable[rowIndex][index].mwDisplayIPair, rowIndex, index + 1)"
             :style="!buttonPushed ? 'cursor:pointer' : 'pointer-events:none'"
             :disabled="buttonPushed"
             :ref="index + 1">
          <div class="flip_face flip_face_front"></div>
          <div class="flip_face flip_face_back" >
            <img :src="twoDimensionalTable[rowIndex][index].card.url">
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'memoryWizard',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      personalizedData: null,
      buttonPushed: true,
      mwDisplayIndexXTable: [],
      twoDimensionalTable: [],
      numOfRow: 0,
      numOfCols: 3,
    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
  },
  mounted() {
    this.viewTheCards();
    this.$nextTick(() => { this.loadImage(); });
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      console.log(this.gameInfo);
      this.createMatrix();
    },
    createMatrix() {
      let index = 0;
      // this.gameInfo = this.gameCardDTOS.slice(0).sort((a, b) => a.mwDisplayIndex - b.mwDisplayIndex);
      this.numOfRow = this.gameInfo.gameCardDTOS.length === 12 ? 4 : 2;
      this.personalizedData = this.gameInfo.gameCardDTOS.slice(0).sort((a, b) => a.mwDisplayIndex - b.mwDisplayIndex);
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.personalizedData[index];
          index += 1;
        }
      }
    },
    viewTheCards() {
      let indexX = 1;
      let indexY = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.$refs[indexX][indexY].classList.add('is-flipped');
          indexX += 1;
        }
        indexX = 1;
        indexY += 1;
      }
      setTimeout(() => {
        this.timeToHideTheCards();
      }, this.gameInfo.hideCardsTimer);
    },
    timeToHideTheCards() {
      let indexX = 1;
      let indexY = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.$refs[indexX][indexY].classList.remove('is-flipped');
          indexX += 1;
        }
        indexX = 1;
        indexY += 1;
      }
      this.buttonPushed = false;
    },
    playNextGame(isCorrectAnswer) {
      console.log('wait 1,5 secs for response and go to next game');
      setTimeout(() => {
        console.log('Go to next game');
        this.normalTransition = true;
        this.storeBrainiacGameData(isCorrectAnswer);
        this.buttonPushed = false;
      }, 1000);
    },
    sendAnswerUntilCompleted(value, pair, rowIndex, colIndex) {
      this.$refs[colIndex][rowIndex].classList.add('is-flipped');
      if (this.mwDisplayIndexXTable.length === 0) {
        this.mwDisplayIndexXTable[0] = value;
        this.mwDisplayIndexXTable[1] = pair;
        this.mwDisplayIndexXTable[2] = colIndex;
        this.mwDisplayIndexXTable[3] = rowIndex;
        this.buttonPushed = false;
      } else if (this.mwDisplayIndexXTable[0] === pair) {
        this.$refs[colIndex][rowIndex].classList.add('is-flipped');
        this.sendAnswer(1, rowIndex, colIndex);
        this.clearArray(this.mwDisplayIndexXTable);
      } else {
        this.sendAnswer(0, rowIndex, colIndex);
        setTimeout(() => {
          this.$refs[this.mwDisplayIndexXTable[2]][this.mwDisplayIndexXTable[3]].classList.remove('is-flipped');
          this.clearArray(this.mwDisplayIndexXTable);
          this.$refs[colIndex][rowIndex].classList.remove('is-flipped');
          this.buttonPushed = false;
        }, 3000);
      }
    },
    clearArray(array) {
      while (array.length) {
        array.pop();
      }
    },
    sendAnswer(value, rowIndex, colIndex) {
      if (this.buttonPushed && this.$refs[colIndex][rowIndex].classList.contains('is-flipped') && this.mwDisplayIndexXTable.length === 0) {
        console.log('--> Wait for Answer....');
      } else {
        this.$refs[colIndex][rowIndex].classList.add('is-flipped');
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${value}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.$refs[colIndex][rowIndex].classList.remove('is-filled');
            } else if (responseData.status === 'CORRECT_ANSWER') {
              this.buttonPushed = false;
              this.$refs[colIndex][rowIndex].classList.add('is-filled');
            } else if (responseData.status === 'USER_FOUND_ALL_PAIRS') {
              this.$refs[colIndex][rowIndex].classList.add('is-filled');
              this.playNextGame(true);
            } else {
              // something bad happened
            }
          }
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'gameCardDTOS',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryWizard.vue